import React from "react";
import { processLinks } from "./hooks/useMessageProcessing";

export default function SafeMessageText({ text, className }) {
  return <div className={className} style={{ whiteSpace: "pre-wrap" }}>{processLinks(text)}</div>;
}
